import "./src/styles/global.css"

export const onClientEntry = () => {
    const fontFiles = [
        require("./src/fonts/Montserrat-Bold.woff2").default,
        require("./src/fonts/Montserrat-Regular.woff2").default,
    ]

    fontFiles.forEach(href => {
        const link = document.createElement("link")
        link.rel = "preload"
        link.as = "font"
        link.type = "font/woff2"
        link.crossOrigin = "anonymous"
        link.href = href
        document.head.appendChild(link)
    })
}

export const onRouteUpdate = ({ location }) => {
    const lang = location.pathname.startsWith("/es") ? "es" : "en"
    document.documentElement.lang = lang
}